import student1_jpg from '../images/01.jpg'
import student2_jpg from '../images/02.jpg'
import student3_jpg from '../images/03.jpg'
import student4_jpg from '../images/04.jpg'
import man_in_suit_jpg from '../images/vecteezy_a-confident-businessman-with-smiling-in-suit-and-tie_51866107.png'
import girl_in_suit_jpg from '../images/vecteezy_ai-generated-young-woman-with-graduation-cap-and-gown-and_41933306.png'
import graduation_hat from '../images/vecteezy_graduation-item-graduation-hat-and-graduation-certificate_13078278.png'
import bag from '../images/vecteezy_vintage-leather-satchel-with-buckles-isolated-on-transparent_55454141.png'
import laptop_jpg from '../images/vecteezy_laptop-and-candlestick_44805628.PNG'
import geetha_jpg from '../images/geetika.jpg'
import broken_instructor_jpg from '../images/dummy_image.png'
import logo from '../images/logo.png'
import login_page_image from '../images/login-img.gif'
import forgot_password_img from '../images/forgot_password_img.gif'
import apple_key_icon from '../images/apple_key.png'
import school1_img from '../images/school1.jpg'
import school2_img from '../images/school2.jpeg'
import school3_img from '../images/school3.jpg'
import school4_img from '../images/school4.jpg'
import secondary_education_img from '../images/secondary_eduaction_img.png'
import math_img from '../images/math.jpeg'
import books_img from '../images/books_img.png'
import Lmslogo from '../images/logo.png'
import broken_course_image from '../images/dummy_course_img.png'

export const images = {
  student1_jpg,
  student2_jpg,
  student3_jpg,
  student4_jpg,
  man_in_suit_jpg,
  girl_in_suit_jpg,
  graduation_hat,
  bag,
  laptop_jpg,
  geetha_jpg,
  broken_instructor_jpg,
  logo,
  login_page_image,
  forgot_password_img,
  apple_key_icon,
  school1_img,
  school2_img,
  school3_img,
  school4_img,
  secondary_education_img,
  math_img,
  books_img,
  Lmslogo,
  broken_course_image
}